import { WebSocketReceiveMessage } from './web-socket-receive-message';

export class WebSocketReceiveReloadUser extends WebSocketReceiveMessage {
  override payload: {
    UserId: string;
  };
}
